import * as React from 'react';
import { render } from 'react-dom';
import ContentMarketingContainer from './content-marketing-container';

export function renderContentMarketing(
    id: string,
    isFrontpage: boolean,
    callback?: () => void,
) {
    if (document) {
        const container = document.getElementById(id + '-container');
        if (container) {
            render(
                <ContentMarketingContainer id={id} isFrontpage={isFrontpage} />,
                container,
                callback,
            );
        }
    }
}
